module.exports = function getResource(label, vars = []) {
    const resources = { checkoutWith: 'Payer avec' };

    return resources[label];
};
